import { Text } from "@chakra-ui/react";

const HeadingText = ({ title, style }) => {
  return (
    <Text
      h={"20px"}
      mt={"6px"}
      fontSize={"14px"}
      fontWeight={"700"}
      lineHeight={"1"}
      letterSpacing={"2%"}
      color={"grey"}
      textTransform={"capitalize"}
      {...style}
    >
      {title}
    </Text>
  );
};

export default HeadingText;
